import React, { useState, useEffect } from "react"

import { useParams, useSearchParams } from "react-router-dom"

import AssessmentViewPrograms from "./AssessmentViewPrograms"
import AssessmentViewPage from "./AssessmentViewPage"

import { ASSESSMENT_PERIOD } from "../../../fastConstants"

const FAST_URL = process.env.REACT_APP_DS_API_URL
const BASE_URL = FAST_URL + "/assessments/"
const LOG_URL = false

export default function AssessmentViewForm(props) {
    // Department(wide) Assessment ID
    const [searchParams, setSearchParams] = useSearchParams()
    const [departmentAssessmentId, setDepartmentAssessmentId] = useState()
    const [departmentId, setDepartmentId] = useState()
    const [department, setDepartment] = useState()
    const [programAssessments, setProgramAssessments] = useState({})
    const {assessmentId} = useParams()
    const [programLearningOutcomes, setProgramLearningOutcomes] = useState({})
    const [themes, setThemes] = useState()

    useEffect(() => {
        let assessmentId = searchParams.get('d')
        if (assessmentId) {
            let url = BASE_URL + searchParams.get('d')
            if (LOG_URL) console.log(url)
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                setDepartmentId(data.departmentId)
                setDepartmentAssessmentId(data.departmentAssessmentId)
                setProgramAssessments(initProgramAssessments(data))
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [searchParams])

    useEffect(() => {
        if (departmentId) {
            let url = BASE_URL + '?departmentId=' + departmentId + '&reviewYear=' + ASSESSMENT_PERIOD
            if (LOG_URL) console.log(url)
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                setDepartment(data)
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [departmentId])

    useEffect(() => {
        if (departmentId) {
            let url = FAST_URL + "/learning-outcome/active/" + departmentId
            if (LOG_URL) console.log(url)
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let currentSlos = {...programLearningOutcomes}
                currentSlos[departmentId] = data
                setProgramLearningOutcomes({...currentSlos})
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [departmentId])

    useEffect(() => {
        let url = FAST_URL + "/themes?active=true"
        if (LOG_URL) console.log(url)
        fetch(url)
        .then(response => {
            return response.json()
        })
        .then(data => {
            setThemes(data)
        })
        .catch(err => {
            console.log(err)
        })
    }, [])

    const initProgramAssessments = (data) => {
        let assessmentMap = {}
        data.programAssessments.forEach((programAssessment) => {
            assessmentMap[programAssessment.programId] = programAssessment
        })
        return assessmentMap
    }
    
    let step
    if (!assessmentId) {
        step = <AssessmentViewPrograms 
                    department={department} 
                    programAssessments={programAssessments}
                    />
    } else {
        step = <AssessmentViewPage 
                    department={department}
                    departmentAssessmentId={departmentAssessmentId}
                    programAssessments={programAssessments}
                    assessmentId={assessmentId}
                    learningOutcomes={programLearningOutcomes}
                    themes={themes}
                    />
    }

    return (
        <React.Fragment>
            <div>
                {step}
            </div>
        </React.Fragment>
    )
}